import { Suspense, useState, useEffect } from "react";
import { AppRoutes } from "@shared/constants";
import { useUserProfile } from "@shared/hooks";
import { useStreak } from "./StreakProvider";
import { MainLayout } from "@widgets/layout";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { Loader } from "@widgets/Loader";
import {
  Community,
  CommunityById,
  EmptyProfile,
  ErrorPage,
  IntrodactionForm,
  Itroduction,
  Match,
  MatchSecondVersion,
  Profile,
  Reactions,
  Streak,
  Tasks,
  UserPage,
} from "@shared/utils";

export const RouterProvider = () => {
  const location = useLocation();
  const {
    isProfileCompleted,
    isLoading: isProfileLoading,
    unfilledFieldsMessage,
  } = useUserProfile();
  const { shouldShowStreak, isLoading: isStreakLoading } = useStreak();
  const [isRouterReady, setIsRouterReady] = useState(false);

  useEffect(() => {
    if (!isProfileLoading && !isStreakLoading) {
      const timer = setTimeout(() => {
        setIsRouterReady(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isProfileLoading, isStreakLoading]);

  const getInitialRoute = () => {
    if (isProfileLoading || isStreakLoading) {
      return <Loader />;
    }

    if (!isProfileCompleted) {
      return (
        <Suspense fallback={<Loader />}>
          <Itroduction />
        </Suspense>
      );
    }

    if (shouldShowStreak) {
      return <Navigate to={`/${AppRoutes.STREAK}`} replace />;
    }

    return <Navigate to={`/${AppRoutes.PROFILE}`} replace />;
  };

  if (!isRouterReady && (isProfileLoading || isStreakLoading)) {
    return <Loader />;
  }

  return (
    <Routes location={location} key={location.pathname}>
      <Route path={AppRoutes.ROOT} element={<MainLayout />}>
        <Route index element={getInitialRoute()} />
        <Route
          path={AppRoutes.MATCH}
          element={
            <Suspense fallback={<Loader />}>
              <Match />
            </Suspense>
          }
        />
        <Route path={AppRoutes.PROFILE} element={<Profile />} />
        <Route
          path={AppRoutes.EMPTY_PROFILE}
          element={
            <Suspense fallback={<Loader />}>
              <EmptyProfile unfilledFieldsMessage={unfilledFieldsMessage} />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.REACTIONS}
          element={
            <Suspense fallback={<Loader />}>
              <Reactions />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.ERROR}
          element={
            <Suspense fallback={<Loader />}>
              <ErrorPage />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.TASKS}
          element={
            <Suspense fallback={<Loader />}>
              <Tasks />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.INTRO_FORM}
          element={
            <Suspense fallback={<Loader />}>
              <IntrodactionForm />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.COMMUNITY}
          element={
            <Suspense fallback={<Loader />}>
              <Community />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.USER}
          element={
            <Suspense fallback={<Loader />}>
              <UserPage />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.STREAK}
          element={
            <Suspense fallback={<Loader />}>
              <Streak />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.COMMUNITY_BY_ID}
          element={
            <Suspense fallback={<Loader />}>
              <CommunityById />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.MATCH_SECOND_VERSION}
          element={<MatchSecondVersion />}
        />
      </Route>
    </Routes>
  );
};
